import { c as _c } from "react/compiler-runtime";
import { ApiWaveParticipationRequirement } from "@/generated/models/ApiWaveParticipationRequirement";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import CreateWaveDropsType from "./CreateWaveDropsType";
export enum ExtendedWaveParticipationRequirement {
  NONE = "NONE",
  IMAGE = "IMAGE",
  AUDIO = "AUDIO",
  VIDEO = "VIDEO",
}
export default function CreateWaveDropsTypes(t0) {
  const $ = _c(8);
  const {
    requiredTypes,
    onRequiredTypeChange
  } = t0;
  let t1;
  if ($[0] !== requiredTypes) {
    t1 = type => {
      switch (type) {
        case ExtendedWaveParticipationRequirement.NONE:
          {
            return requiredTypes.length === 0;
          }
        case ExtendedWaveParticipationRequirement.IMAGE:
          {
            return requiredTypes.includes(ApiWaveParticipationRequirement.Image);
          }
        case ExtendedWaveParticipationRequirement.AUDIO:
          {
            return requiredTypes.includes(ApiWaveParticipationRequirement.Audio);
          }
        case ExtendedWaveParticipationRequirement.VIDEO:
          {
            return requiredTypes.includes(ApiWaveParticipationRequirement.Video);
          }
        default:
          {
            assertUnreachable(type);
            return false;
          }
      }
    };
    $[0] = requiredTypes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const checkIsChecked = t1;
  const extendedTypeToWaveParticipationRequirement = _temp;
  let t2;
  if ($[2] !== onRequiredTypeChange) {
    t2 = type_1 => {
      const waveParticipationRequirement = extendedTypeToWaveParticipationRequirement(type_1);
      if (waveParticipationRequirement) {
        onRequiredTypeChange([waveParticipationRequirement]);
      } else {
        onRequiredTypeChange([]);
      }
    };
    $[2] = onRequiredTypeChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onChange = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="tw-mb-0 tw-text-lg  sm:tw-text-xl tw-font-semibold tw-text-iron-50">Required Types</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== checkIsChecked || $[6] !== onChange) {
    t4 = <div>{t3}<div className="tw-mt-3 tw-flex tw-flex-wrap sm:tw-flex-row tw-gap-x-4 tw-gap-y-4">{Object.values(ExtendedWaveParticipationRequirement).map(type_2 => <CreateWaveDropsType key={type_2} isChecked={checkIsChecked(type_2)} type={type_2} onRequiredTypeChange={onChange} />)}</div></div>;
    $[5] = checkIsChecked;
    $[6] = onChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(type_0) {
  switch (type_0) {
    case ExtendedWaveParticipationRequirement.NONE:
      {
        return null;
      }
    case ExtendedWaveParticipationRequirement.IMAGE:
      {
        return ApiWaveParticipationRequirement.Image;
      }
    case ExtendedWaveParticipationRequirement.AUDIO:
      {
        return ApiWaveParticipationRequirement.Audio;
      }
    case ExtendedWaveParticipationRequirement.VIDEO:
      {
        return ApiWaveParticipationRequirement.Video;
      }
    default:
      {
        assertUnreachable(type_0);
        return null;
      }
  }
}